import script from "./InscriptionNotary.vue?vue&type=script&setup=true&lang=js"
export * from "./InscriptionNotary.vue?vue&type=script&setup=true&lang=js"

import "./InscriptionNotary.vue?vue&type=style&index=0&id=485ddd78&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485ddd78"]])

export default __exports__